import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import _isFunction from "lodash/isFunction";
import "regenerator-runtime/runtime.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.define-property.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form, Input, Button, Dropdown, showSuccess } from 'components';
import { addBorrowerIncome, editBorrowerIncome } from 'services';
import { showApiError, positiveDoublePattern } from 'utils';
import { incomeBeneficiaryTypesNameSelect, incomeSourceTypesNameSelect } from 'enums';
import { jsx as ___EmotionJSX } from "@emotion/react";

var BorrowerIncomeForm = function BorrowerIncomeForm(_ref) {
  var data = _ref.data,
      idNumber = _ref.idNumber,
      onCancel = _ref.onCancel,
      onBorrowerChange = _ref.onBorrowerChange;

  var initialData = _objectSpread({}, data);

  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
      var values, isEdited, body, method, params, _yield$method, _yield$method2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              values = _ref2.values, isEdited = _ref2.isEdited;
              body = _objectSpread({}, values);

              if (!isEdited) {
                _context.next = 18;
                break;
              }

              method = data ? editBorrowerIncome : addBorrowerIncome;
              params = data ? [data === null || data === void 0 ? void 0 : data.id, body] : [idNumber, body];
              _context.next = 7;
              return method.apply(void 0, params);

            case 7:
              _yield$method = _context.sent;
              _yield$method2 = _slicedToArray(_yield$method, 2);
              res = _yield$method2[0];
              err = _yield$method2[1];

              if (!err) {
                _context.next = 14;
                break;
              }

              showApiError(err);
              return _context.abrupt("return", true);

            case 14:
              showSuccess("\u041F\u0440\u0438\u0445\u043E\u0434\u0430 ".concat(data ? 'редактирана' : 'добавена', " \u0443\u0441\u043F\u0435\u0448\u043D\u043E."));
              _isFunction(onBorrowerChange) && onBorrowerChange(res);
              _context.next = 19;
              break;

            case 18:
              _isFunction(onCancel) && onCancel();

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Form, {
    onSubmit: handleSubmit,
    values: initialData
  }, ___EmotionJSX(Row, {
    horizontalGap: 16
  }, ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Dropdown, {
    required: true,
    formId: "beneficiary",
    label: "\u041D\u0430",
    options: incomeBeneficiaryTypesNameSelect,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Dropdown, {
    required: true,
    formId: "source",
    label: "\u041E\u0442",
    options: incomeSourceTypesNameSelect,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    formId: "amount",
    label: "\u0421\u0443\u043C\u0430",
    number: true,
    pattern: positiveDoublePattern,
    validate: function validate(val) {
      return (val <= 0 || !val) && {
        msg: 'Въведете положително число!'
      };
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX(Input, {
    type: "textarea",
    formId: "description",
    label: "\u0414\u0435\u0442\u0430\u0439\u043B\u0438"
  })), ___EmotionJSX(Col, {
    displayFlex: true,
    md: 12,
    justify: "flex-end"
  }, function (_ref4) {
    var onSubmit = _ref4.onSubmit;
    return ___EmotionJSX(React.Fragment, null, _isFunction(onCancel) && ___EmotionJSX(Button, {
      type: "secondary",
      onClick: onCancel,
      margin: "0 1em 0 0"
    }, "\u0417\u0430\u0442\u0432\u043E\u0440\u0438"), ___EmotionJSX(Button, {
      onClick: onSubmit
    }, data ? 'Запази' : 'Добави'));
  }))));
};

BorrowerIncomeForm.propTypes = {
  idNumber: PropTypes.string,
  onBorrowerChange: PropTypes.func,
  onCancel: PropTypes.func,
  data: PropTypes.object
};
export default BorrowerIncomeForm;